import { BaseColumns } from '@/modules/core/table/models/BaseColumns';
import { TableColumn } from '@/modules/core/table/models/TableColumn';
import { ColumnFormat } from '@/modules/core/app/constants/data.constants';
import NumeralService from '@/modules/core/app/services/NumeralService';
import { CalculatorLineItem } from '@/modules/tax/models/calculators/CalculatorLineItem';

export class ProbateCalculatorBreakdownColumns extends BaseColumns {
  identifier: TableColumn;
  label: TableColumn;
  value: TableColumn;

  constructor() {
    super();

    this.identifier = new TableColumn({
      field: 'identifier',
      isCustomCellRender: true
    });

    this.label = new TableColumn({
      field: 'label',
      customRenderFn(data: CalculatorLineItem): string {
        return data.alternativeLabel ?? data.label;
      }
    });

    this.value = new TableColumn({
      field: 'value',
      format: ColumnFormat.FORMAT_CURRENCY,
      customRenderFn(data: CalculatorLineItem): string {
        return NumeralService.formatValue(data.column.value, ColumnFormat.FORMAT_CURRENCY, 2);
      }
    });
  }
}
